<template lang="pug">
  div
    sidebar
      transition-group.group-list(name="list-complete" mode="out-in" tag="ul")
        li.list-complete-item(key="groups")
          router-link.group-link(:to="{name: 'groups'}")
            span {{$t('shared_group')}}
    div.lmm-content-body
      router-view
</template>

<script>
import Sidebar from "@/components/mixins/sidebar"
import store from "@/api/store"

export default {
  name: "groups-component",
  components: { sidebar: Sidebar },
  methods: {
    getUserData() {
      let stored = store.get("summary")
      this.summary = stored
    },
  },
  created() {
    this.getUserData()
  },
  data() {
    return {
      summary: {},
    }
  },
}
</script>